export default {
  namespaced: true,
  state: {
    isPaymentCheckEnabled: false,
  },
  mutations: {
    SET_PAYMENT_CHECK_SWITCHER(state, val) {
      return (state.isPaymentCheckEnabled = val);
    },
  },
};
